import {useExperimentalMode} from "../useExperimentalMode";

const NAVBAR_WIDTH_EXPANDED = 278;
const NAVBAR_WIDTH_COLLAPSED = 70;

export function useNavbarWidth() {
    const {isExperimental} = useExperimentalMode();

    return {
        expanded: NAVBAR_WIDTH_EXPANDED,
        collapsed: isExperimental ? 0 : NAVBAR_WIDTH_COLLAPSED,
    };
}
